import { formatNode } from "../node/index.js";
import {} from "../port/index.js";
import {} from "./Net.js";
import { createPortFromPortEntry } from "./createPortFromPortEntry.js";
import { findPortRecordOrFail } from "./findPortRecordOrFail.js";
export function findPrincipalPort(net, node) {
    const portRecord = findPortRecordOrFail(net, node);
    for (const portEntry of Object.values(portRecord)) {
        if (portEntry.isPrincipal) {
            return createPortFromPortEntry(node, portEntry);
        }
    }
    throw new Error([
        `[findPrincipalPort] I expect the node to have a principal port.`,
        ``,
        `  node: ${formatNode(net, node)}`,
    ].join("\n"));
}
//# sourceMappingURL=findPrincipalPort.js.map